import { atom } from "jotai";

export const showMenuAtom = atom(true);

export const showCameraAtom = atom(false);

export const isTmaEnvironmentAtom = atom(() => false);

export const mainButtonAtom = atom<{
  title?: string;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  hidden?: boolean;
}>({});

export const secondaryButtonAtom = atom<{
  title?: string;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  hidden?: boolean;
}>({});

export const catalogScrollPositionAtom = atom<number>(0);

declare global {
  interface Window {
    Capacitor?: {
      getPlatform?: () => string;
      isNativePlatform?: () => boolean;
    };
  }
}
